import { delay } from "../../utils";
import { ICandyApiDraftTasksClient } from "../../../../../Common/CandyApiClient/ICandyApiClient";
import { TaskStatus } from "../../../../../Common/CandyApiClient/Types/Tasks/Tasks";

type ProgressCallback = (done: number, total: number) => void;

export class CancellationError {
    public code = "Cancelled";
    public message: string;

    public constructor(message: string) {
        this.message = message;
    }
}

export class VerifyAndFixFnsRequirementsTask {
    private readonly candyApiDraftTasksClient: ICandyApiDraftTasksClient;
    private readonly progressListeners: ProgressCallback[] = [];
    private readonly id: string;
    private readonly attachmentId: string;
    private canceled = false;

    public constructor(candyApiDraftTasksClient: ICandyApiDraftTasksClient, id: string, attachmentId: string) {
        this.candyApiDraftTasksClient = candyApiDraftTasksClient;
        this.id = id;
        this.attachmentId = attachmentId;
    }

    public async startTask(): Promise<void> {
        await this.candyApiDraftTasksClient.enqueueTask(this.id, {
            attachmentId: this.attachmentId,
            type: "VerifyAndFixFnsRequirements",
        });
        await this.poll();
    }

    public async cancel(): Promise<void> {
        this.canceled = true;
        await this.candyApiDraftTasksClient.cancelTask(this.id);
    }

    public progress(callback: ProgressCallback): void {
        this.progressListeners.push(callback);
    }

    private readonly poll = async (): Promise<void> => {
        if (this.canceled) {
            return;
        }

        const taskInfo = await this.candyApiDraftTasksClient.getTaskById(this.id);
        if (taskInfo == undefined) {
            return;
        }

        switch (taskInfo.status) {
            case TaskStatus.Cancelled:
                // eslint-disable-next-line @typescript-eslint/only-throw-error
                throw new CancellationError("Cancel task");
            case TaskStatus.Error: {
                // eslint-disable-next-line @typescript-eslint/only-throw-error
                throw taskInfo.error;
            }
            case TaskStatus.InProgress: {
                for (const callback of this.progressListeners) {
                    callback(taskInfo.progress.done, taskInfo.progress.total);
                }
                await delay(1000);
                await this.poll();
                break;
            }
            case TaskStatus.Success:
                break;
            default:
                break;
        }
    };
}
